import React, {useContext} from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import {useTranslation} from "react-i18next";
import i18next from 'i18next'
import {useDispatch, useSelector} from "react-redux";
import {AuthContext} from "../context/authcontext";
import {SET_THEME} from "../redux/types";

const logout = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="sign-out-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor"d="M160 217.1c0-8.8 7.2-16 16-16h144v-93.9c0-7.1 8.6-10.7 13.6-5.7l141.6 143.1c6.3 6.3 6.3 16.4 0 22.7L333.6 410.4c-5 5-13.6 1.5-13.6-5.7v-93.9H176c-8.8 0-16-7.2-16-16v-77.7m-32 0v77.7c0 26.5 21.5 48 48 48h112v61.9c0 35.5 43 53.5 68.2 28.3l141.7-143c18.8-18.8 18.8-49.2 0-68L356.2 78.9c-25.1-25.1-68.2-7.3-68.2 28.3v61.9H176c-26.5 0-48 21.6-48 48zM0 112v288c0 26.5 21.5 48 48 48h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48C21.5 64 0 85.5 0 112z"></path></svg>
const globe = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="globe" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z"></path></svg>

const languages = [
    {
        code: "en",
        name: "English"
    },
    {
        code: "ru",
        name: "Русский"
    },
    {
        code: "uz",
        name: "O'zbekcha"
    }
]

const Navbar = () => {

    const {t} = useTranslation()
    const auth = useContext(AuthContext)
    const history = useHistory()
    const dispatch = useDispatch()

    const theme = useSelector(state => state.app.theme)

    const toggleTheme = async () => {
        if (theme === 'light') {
            dispatch({type: SET_THEME, payload: 'dark'})
            await localStorage.setItem('theme', JSON.stringify({
                theme: 'dark'
            }))
        } else {
            dispatch({type: SET_THEME, payload: 'light'})
            await localStorage.setItem('theme', JSON.stringify({
                theme: 'light'
            }))
        }
    }

    const toggleMenu = () => {
        const menu = document.querySelector('.menus')
        const burger = document.querySelector('.burger-wrapper')
        menu.classList.toggle("open")
        burger.classList.toggle("burger-open")
    }

    const logoutFn = (event) => {
        event.preventDefault()
        auth.logout()
        history.push('/')
    }

    const showLanguages = () => {
        const list = document.querySelector('.languages-list')
        list.classList.toggle('visible')
    }

    const redirectToHomePage = () => {
        history.push('/')
    }

    return (
        <nav className={theme}>
            <div className="content nav-wrapper">
                <div className="logo" onClick={redirectToHomePage}>
                    Forset
                </div>
                <div className="menus">
                    <li>
                        <button onClick={showLanguages}>
                            {globe}
                        </button>
                        <div className={`languages-list ${theme}`}>
                            {
                                languages.map(({code, name}) => {
                                    return (
                                        <div key={code} className={`lang ${theme}`}>
                                            <button className="language-select" onClick={() => {
                                                i18next.changeLanguage(code)
                                                showLanguages()
                                            }}>
                                                {name}
                                            </button>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </li>
                    <li className="center">
                        <div className={`theme ${theme}`} onClick={toggleTheme}/>
                    </li>
                    <li><NavLink to="/carslist" activeClassName="current">{t('cars')}</NavLink></li>
                    <li><NavLink to="/clientslist" activeClassName="current">{t('allClients')}</NavLink></li>
                    <li><NavLink to="/orders" activeClassName="current">{t('orders')}</NavLink></li>
                    <li><NavLink to="/analytics" activeClassName="current">{t('analytics')}</NavLink></li>
                    <li><NavLink to="/addclient" activeClassName="current">{t('addClient')}</NavLink></li>
                    <li><NavLink to="/telegramclients" activeClassName="current">TG {t('clients')}</NavLink></li>
                    <li><button onClick={logoutFn}>{logout}</button></li>
                </div>
                <div className="burger-wrapper" onClick={toggleMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </nav>
    )
}

export default React.memo(Navbar)